import { createFileRoute } from "@tanstack/react-router";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import DoubleBlogRedirect from "@/components/LegacyRedirects";

export const Route = createFileRoute("/es/blog/blog/$slug")({
  loader: ({ params }) => loadContentMeta("blog_posts", params.slug, "es"),
  head: ({ params, loaderData }) =>
    buildContentHead(`/es/blog/blog/${params.slug}`, loaderData),
  component: DoubleBlogRedirect,
});

